

































































import { Vue, Component, Ref } from 'vue-property-decorator'

import DataTableDeCrud from '@/components/ui/DataTableDeCrud.vue'
import DialogoDeEdicaoDePlugin from '@/components/plugin/DialogoDeEdicaoDePlugin.vue'

import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import PluginModule from '@/store/vuex/aplicacao/PluginStore'
import { FormPlugin, Plugin } from '@/models'
import { ambiente } from '@/shareds/utils'
import * as pluginApi from '@/api/plugin'

@Component({
	components: {
		DialogoDeEdicaoDePlugin,
		DataTableDeCrud,
	},
})
export default class TelaDePlugins extends Vue {
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDePlugin
	PluginModule = PluginModule
	AlertModule = AlertModule
	loading = false

	cadastrarPlugin() {
		this.dialogoDeEdicao.mostrar({
			nome: '',
			url: '',
			debug: false,
			configs: {},
			ativo: true,
			env: this.getEnv(),
			configsPorLoja: [],
		})
	}

	async editarPlugin(indice: number) {
		const plugin = PluginModule.plugins[indice]
		const pluginCompleto = await pluginApi.get(plugin.id)

		this.dialogoDeEdicao.mostrar({
			id: pluginCompleto.id,
			nome: pluginCompleto.nome,
			url: pluginCompleto.url,
			debug: pluginCompleto.debug,
			configs: { ...pluginCompleto.configs },
			ativo: pluginCompleto.ativo,
			env: pluginCompleto.env,
			configsPorLoja: pluginCompleto.configsPorLoja,
		})
	}

	async gravarPlugin(plugin: FormPlugin) {
		PluginModule.gravarPlugin(plugin)
		console.log(plugin)
	}

	excluirPlugin(indice: number) {
		const plugin = PluginModule.plugins[indice]
		PluginModule.excluirPlugin(plugin.id)
	}

	abrirDialog(plugin: Plugin) {
		plugin.abrirDialog()
	}

	pingarPlugin(plugin: Plugin) {
		plugin.log(`PING enviado`)
		plugin.emit('ping')
	}

	async testarFuncaoAssincrona(plugin: Plugin) {
		try {
			this.loading = true
			const a = Math.floor(Math.random() * 10)
			const b = Math.floor(Math.random() * 10)
			const result = await plugin.asyncMessage('testeFuncaoAsync', [a, b])
			AlertModule.setSuccess('Resultado de soma aleatórioa: ' + result)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.loading = false
		}
	}

	created() {
		PluginModule.on('ping', () => PluginModule.emit('pong'))
		PluginModule.on('pong', () => console.log('PONG recebido'))
	}

	destroyed() {
		PluginModule.removeListener('ping')
		PluginModule.removeListener('pong')
	}

	getEnv() {
		switch (ambiente) {
			case 'Produção':
				return 'production'
			case 'Staging':
				return 'staging'
			case '': {
				if (process.env.NODE_ENV === 'production') {
					return 'staging'
				}
				return 'staging'
			}
			default:
				return 'staging'
		}
	}
}
